import { useEffect, useRef } from "react";
import "./message-creation-flow.css";
import Step1 from "./step1/Step1";
import Step2 from "./step2/Step2";
import Step3 from "./step3/Step3";
import Step4 from "./step4/Step4";
import StepsTracker from "./steps-tracker/StepsTracker";
import {FormValuesProps} from "../modals/notificationModals/NewNotificationModal";
import StepsProcess from "../stepsProcess/StepsProcess";
import {FieldTimeOutlined, MessageOutlined, SlidersOutlined, SmileOutlined} from "@ant-design/icons";
import useAppContext from "../../hooks/useAppContext";
import {FlowTriggerProps} from "../../types/FlowTriggerProps";
import {getPossibleMessageTypesByTrigger} from "../../utils/getPossibleMessageTypesByTrigger";
import TargetIcon from "../../assets/icons/TargetIcon";
import PreCreationStep from "./preCreateStep/PreCreationStep";

interface MessageCreationFlowProps {
    onClose: () => void;
    formValues: FormValuesProps;
    onFormUpdate: (newValues: FormValuesProps) => void;
    step: number;
    setStep: (newStep: number) => void;
    stepsDone: number;
    setStepsDone: (newStep: number) => void;
    isLoading: boolean;
    onCreateNewNotification: () => Promise<boolean>;
    flowTriggerId: number;
}

const MessageCreationFlow = ({ flowTriggerId, onClose, formValues, onFormUpdate, isLoading, onCreateNewNotification }: MessageCreationFlowProps) => {
    const { data: { flowTriggers, flowTypes }} = useAppContext();
    const flowTrigger = flowTriggers.data.find((trigger: FlowTriggerProps) => trigger.id === flowTriggerId);

    const possibleMessageTypes = getPossibleMessageTypesByTrigger(flowTrigger, flowTypes.data);
    const isMultipleTypes = possibleMessageTypes?.length > 1;
    const steps = [
        // ...(isMultipleTypes ? [{
        //     title: 'Your Goal',
        //     icon: <TargetIcon width={24} />
        // }] : []),
        ...(flowTriggerId > 1 ? [{
            title: 'Purpose',
            icon: <FieldTimeOutlined />,
        }] : []),
        {
            title: 'Message Details',
            icon: <MessageOutlined />,
        },
        ...(flowTriggerId === 1 ? [{
            title: 'Schedule',
            icon: <FieldTimeOutlined />,
        }] : []),
        {
            title: 'Activation',
            icon: <SlidersOutlined />,
        },
        {
            title: 'Done',
            icon: <SmileOutlined />,
        },
    ];

    useEffect(() => {
        if(!isMultipleTypes && flowTriggerId === 1) {
            onFormUpdate({ ...formValues, requiresConsent: true });
        }
    }, [isMultipleTypes]);

    return (
        <div className="message-creation-flow-container">
            <StepsProcess steps={steps} onFirstSentenceBack={onClose} showProgressCircles={false}>
                {isMultipleTypes ? <PreCreationStep possibleMessageTypes={possibleMessageTypes} formValues={formValues} setFormValues={onFormUpdate} flowTriggerId={flowTriggerId} /> : null}
                <Step1 formValues={formValues} setFormValues={onFormUpdate} flowTriggerId={flowTriggerId} isFirstStep={!isMultipleTypes} />
                <Step2 formValues={formValues} setFormValues={onFormUpdate} flowTriggerId={flowTriggerId} />
                <Step3 formValues={formValues} setFormValues={onFormUpdate} isLoading={isLoading} onCreateNewNotification={onCreateNewNotification} />
                <Step4 onClose={onClose} formValues={formValues} />
            </StepsProcess>
        </div>
    )
}

export default MessageCreationFlow;